import { Site } from '@iss/libs/graphql';
import { IfHasPermissionPipe } from '@iss/libs/auth';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { ConditionalLinkComponent } from '../conditional-link';

import { AppRoutingLinks } from '@wo-mc/routing';

@Component({
  selector: 'wo-site-link',
  templateUrl: './site-link.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    ConditionalLinkComponent,
    IfHasPermissionPipe,
  ],
})
export class SiteLinkComponent {
  public readonly AppRoutingLinks = AppRoutingLinks;
  @Input() public id?: Site['id'];
}
